import { render, staticRenderFns } from "./wiki-object-card.vue?vue&type=template&id=31fb80e9&"
import script from "./wiki-object-card.vue?vue&type=script&lang=ts&"
export * from "./wiki-object-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports